var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-card",
    { attrs: { title: _vm.$t("menu.clinical_documents") } },
    [
      _c("paginated-table", {
        attrs: {
          fields: _vm.fields,
          items: _vm.documentsTable.files,
          loading: _vm.documentsTable.loading,
          "empty-text": _vm.$t("no-documents-found")
        },
        scopedSlots: _vm._u([
          {
            key: "cell(preview)",
            fn: function(data) {
              return [
                _c("img", {
                  staticClass: "clickable",
                  attrs: {
                    src:
                      "/static-appopensalud/img/icons/morillas-svg-icons/primary-filled/eye.svg"
                  },
                  on: {
                    click: function($event) {
                      return _vm.buildLightboxItem(data.item.url)
                    }
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c(
            "div",
            { staticClass: "mt-2 mb-2" },
            [
              _c("b-icon-upload", { staticClass: "mr-2" }),
              _vm._v(_vm._s(_vm.$t("upload-files")))
            ],
            1
          ),
          _vm._v(" "),
          _vm.documentsTable.uploader.fileTypes
            ? _c("base-select", {
                attrs: {
                  options: _vm.documentsTable.uploader.fileTypes,
                  label: "name." + _vm.$i18nHelpers.getNormalizedLocale(),
                  valueProp: "id",
                  placeholder: _vm.$t("select-file-type"),
                  autoDropdownPlacement: ""
                },
                model: {
                  value: _vm.uploaderSelectedType,
                  callback: function($$v) {
                    _vm.uploaderSelectedType = $$v
                  },
                  expression: "uploaderSelectedType"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("b-form-file", {
            staticClass: "mt-2",
            attrs: {
              placeholder: _vm.$t("select-or-drag-drop-file"),
              "drop-placeholder": _vm.$t("drag-drop-file"),
              "browse-text": _vm.$t("browse")
            },
            on: { input: _vm.uploadFile },
            model: {
              value: _vm.uploaderFile,
              callback: function($$v) {
                _vm.uploaderFile = $$v
              },
              expression: "uploaderFile"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66c319b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66c319b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/DocumentsTable.vue
// module id = 3684
// module chunks = 31